import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
    createTextVNode as _$ct,
    className as _$cn,
} from 'intact';
import {BubbleList, Tag} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(BubbleList, {
        'className': 'bubble-list-demo-custom-item',
        'items': this.get('items'),
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['item'] = function($super, scope) {
                        return (
                            _$ce(2, 'div', [
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ce(2, 'span', scope.item.title, 0),
                                        _$cc(Tag, {
                                            'type': this.getKindTagType(scope.item.kind),
                                            'children': (
                                                (scope.item.kind === 'summary') ?
                                                    _$ce(2, 'span', '摘要', 16) :
                                                    _$ce(2, 'span', '操作', 16)
                                            )
                                        })
                                    ], 4, 'bubble-list-demo-custom-item-title'),
                                    _$ce(2, 'div', scope.item.content, 0, 'bubble-list-demo-custom-item-content')
                                ], 4, 'bubble-list-demo-custom-item-main'),
                                _$ce(2, 'div', [
                                    _$ct('\n                #'),
                                    scope.index + 1
                                ], 0, 'bubble-list-demo-custom-item-meta')
                            ], 4, _$cn(this.getRowClass(scope.item.kind)))
                        );
                    }),
                    (__$blocks['item'] = function($super, data) {
                        var block = $blocks['item'];
                        var callBlock = function() {
                            return _$blocks['item'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    });
};